import React, { useState } from 'react';
import * as Yup from 'yup';
import { Field, Formik, Form } from 'formik';
import { map, size, filter, slice, isEmpty } from 'lodash';
import { Row, Col } from 'antd';
import { object, func, string } from 'prop-types';
import { Text, Divider, Icon, FlexContainer, FormikInput, Button } from '../../common';
import { UPDATE_MAIL_REPORT } from '../../../queries';

const Card = ({ client, addressees, name, itemKey, setInfoToModalDelete, setVisibleModalDelete, setDrawerEmails, setDrawerItemKey, setVisibleModaDetail }) => {
    const [loading, setLoading] = useState(false);
    const [emailAlreadyExistError, setEmailAlreadyExistError] = useState(false);
    const truncateText = (text, sizeToTruncate) => size(text) > sizeToTruncate ? `${text.substring(0, sizeToTruncate - 1)}...` : text;
    const listEmails = addressees;

    const ValidationSchema = Yup.object().shape({
        email: Yup.string()
            .email('form.validations.email')
    });

    const EmailForm = ({ handleSubmit }) => {
        return <Form onSubmit={handleSubmit} onChange={() => setEmailAlreadyExistError(false)}>
            <Col span={20}>
                <Field
                    style={{ margin: 0 }}
                    component={FormikInput}
                    name='email'
                    placeholder='Ingresar email'
                />
                {emailAlreadyExistError && <span style={{ fontSize: 11, padding: '5px 0px', color: '#d60101' }}>Email ya existe</span>}
            </Col>
            <Col span={4}>
                <Button
                    disabled={loading}
                    loading={loading}
                    htmlType='submit'
                    backgroundColor='#a4c735'
                >
                    <Icon name='plus' size='12' color='#ffffff' />
                </Button>
            </Col>
        </Form>;
    };

    return <Col xs={24} md={12} lg={8} xl={8} xxl={6}>
        <FlexContainer
            direction='column'
            grow={1}
            style={{
                height: 'fit-content',
                minHeight: 370,
                backgroundColor: '#ffffff',
                margin: '24px 8px 0px 8px',
                borderRadius: 3,
                padding: 15,
                boxSizing: 'border-box'
            }}
        >
            <Text text={name} strong size={16} style={{ marginBottom: 10 }} />
            <Row gutter={16} style={{ marginBottom: 10 }}>
                <Formik
                    onSubmit={async ({ email }) => {
                        const alreadyEmail = size(filter(addressees, addressee => addressee === email)) > 0;
                        if (alreadyEmail) return setEmailAlreadyExistError(true);

                        setLoading(true);

                        await client.mutate({
                            mutation: UPDATE_MAIL_REPORT,
                            variables: {
                                input: {
                                    jobName: itemKey,
                                    email: email,
                                    "enabled": true
                                }
                            },
                            refetchQueries: ['getMailReport']
                        });

                        setLoading(false);
                    }}
                    validationSchema={ValidationSchema}
                    render={EmailForm}
                />
            </Row>
            {map(slice(listEmails, 0, 7), (email, index) => {
                return <Row key={email + index}>
                    <Divider style={{ margin: '5px 0px' }} />
                    <Row gutter={16}>
                        <Col span={20}>
                            <Text text={truncateText(email, 37)} truncate size={12} />
                        </Col>
                        <Col span={4} style={{ textAlign: 'center' }}>
                            <Icon name='trash' color='#A4C735' size={12} pointer onClick={async () => {
                                setInfoToModalDelete({ email, itemKey });
                                setVisibleModalDelete(true);
                            }} />
                        </Col>
                    </Row>
                </Row>;
            })}
            {(!isEmpty(listEmails) && size(listEmails) > 7) && <FlexContainer justify='flex-end'>
                <Row style={{ bottom: 0, position: 'absolute', marginBottom: 5 }}>
                    <div className='with-fb'>
                        <a onClick={() => {
                            setDrawerEmails(listEmails);
                            setDrawerItemKey(itemKey);
                            setVisibleModaDetail(true);
                        }}>
                            <div className='text' style={{ fontSize: 12 }}>Ver más...</div>
                        </a>
                    </div>
                </Row>
            </FlexContainer>}
        </FlexContainer>
    </Col>;
};

Card.propTypes = {
    addressees: object,
    client: object,
    name: string,
    itemKey: string,
    setInfoToModalDelete: func,
    setVisibleModalDelete: func,
    setDrawerEmails: func,
    setDrawerItemKey: func,
    setVisibleModaDetail: func
};

export default Card;
